import {Container, Row} from 'react-bootstrap';
import {useEffect, useState} from 'react';
import {of, switchMap} from 'rxjs';
import withObservables from '@nozbe/with-observables';
import {bulkUpdateOrderProductQuantity, observeActiveOrder, observeGetOrderById} from '../../../../../pos-core/database/helpers';
import {BillAmountBox, LeftPane, NonIdealScreen, PosDiscountModal, RightPane, TaxesModal, ToastBox, TransactionSuccessfulModal} from '../../../../common';
import OrderItem from '../../POS/CreateOrder/OrderLine';
import NonIdeal from '../CreateOrder/NonIdeal';
import {DEVICE_HEIGHT, handleUpdateProductQty} from '../../../../../constants';
import {useAuthContext, useLanguageContext, useThemeContext} from '../../../../../context';
import CashMethod from './CashMethod';
import CardMethod from './CardMethod';
import {useOrderCalculation, useSessionUser} from '../../../../../hooks';
import {Sync} from '../../../../../api';
import useShortcut from '../../../../../hooks/useShortcut';
import {ItemDiscountsModal, NewPosHeader, SelectedCustomerModal, VerificationModal, WalletPaymentModal} from '../../../../common/V2';
import PaymentMethod from './PaymentMethod';
import useFocus from '../../../../../hooks/useFocus';
import WalletMethod from './WalletMethod';
import SplitBillModal from '../../../../common/SplitBillModal';
import {useNavigate} from 'react-router-dom';
import ItemNotesModal from '../../../../common/ItemNotesModal';

const OrderPayment = ({orders, orderLines, customer, discount, sales_tax}) => {
    let order = orders[0];
    const {theme} = useThemeContext();
    const {I18n} = useLanguageContext();
    const {business, user} = useAuthContext();
    const {localUser} = useSessionUser();
    const queryString = window.location.search;
    const parts = queryString?.split('id=');
    const orderNumber = parts[1];

    const isRestaurantPos = orderNumber ? true : false;

    const [selectedAction, setSelectedAction] = useState('cash');
    const [customerDetailModal, setCustomerDetailModal] = useState(false);
    const [posDiscountModal, setPosDiscountModal] = useState(false);
    const [selectCustomer, setSelectCustomer] = useState(false);
    const [successModal, setSuccessModal] = useState(false);
    const [taxModal, setTaxModal] = useState(false);
    const [posDiscount, setPosDiscount] = useState(discount || undefined);
    const [orderDiscountModal, setOrderDiscountModal] = useState(false);
    const [orderselectedItem, setOrderselectedItem] = useState({});
    const [selectedWallet, setSelectedWallet] = useState('');
    const [toggleWalletModal, setToggleWalletModal] = useState(false);
    const [toggleVerifyModal, settoggleVerifyModal] = useState(false);
    const [splitBillModal, setSplitBillModal] = useState(false);
    const [orderNotes, setOrderNotes] = useState(null);
    const [customerInfo, setCustomerInfo] = useState({});
    const [showMessage, setShowMessage] = useState({
        visible: false,
        message: '',
    });

    const {subTotal, amount, setAmount, change, total, tax, givenPosDiscount, giveItemLevelDiscount, inclusive, exclusive, redeemAmount} = useOrderCalculation({
        order,
        orderLines,
        discount,
        sales_tax,
        isRestaurantPos,
    });
    const navigate = useNavigate();

    useEffect(() => {
        if (showMessage.visible) {
            const timeoutId = setTimeout(() => {
                setShowMessage({
                    visible: false,
                    message: '',
                });
            }, 3000);
            return () => clearTimeout(timeoutId);
        }
    }, [showMessage]);

    const handlePayment = type => {
        setSelectedAction(type);
    };

    const handleProduct = (val, event) => {
        handleUpdateProductQty(val, event, orderLines, order);
    };

    const handlePosDiscount = async val => {
        setPosDiscount(val);
        await order.updatePosDiscount(val);
        setPosDiscountModal(false);
    };

    const handleDeletePosDiscount = async () => {
        setPosDiscountModal(false);
        setPosDiscount();
        await order.updatePosDiscount(null);
    };

    const handleDeleteTax = async () => {
        setTaxModal(false);
        await order.updateTax(null);
    };

    const togglePosDiscount = () => {
        setPosDiscountModal(prev => !prev);
    };

    const toggleSelectCustomer = async () => {
        setSelectCustomer(true);
    };

    const handleCreateCustomer = () => {
        navigate(`/customers/create?id=${order.number}`);
    };

    const handleSelectCustomer = async val => {
        const customerId = order?.customer?.id;
        let message = '';
        if (val == 'removeCustomer') {
            await order?.updateCustomer(null);
            message = I18n.remove_Customer;
        } else {
            message = customerId ? I18n.update_Customer : I18n.customer_added;
            await order?.updateCustomer(val);
        }

        setSelectCustomer(false);
        setShowMessage({
            visible: true,
            message: message,
        });
    };

    const handleTax = async val => {
        await order.updateTax(val);
        setTaxModal(false);
    };

    const handleDone = async method => {
        if (successModal || amount < total) return;

        const filteredOrderLines = orderLines.filter(ord => !ord.is_open);
        await bulkUpdateOrderProductQuantity(filteredOrderLines, 'sale');

        let paramsForOrder = {
            user: localUser,
            payment_method: method,
            total,
            amount: Number(amount),
            change: Number(change),
        };

        console.log('paramsForOrder', paramsForOrder);
        let finalOrder = await order.updateOrderCompletion(paramsForOrder);

        if (!isRestaurantPos) {
            // create payment for retail orders here.
            let payParams = {
                order: finalOrder,
                card_number: '4242 4242 4242 4242',
                type: 'visa',
                status: 'complete',
                total: finalOrder.total,
                completed_at: new Date().getTime(),
                expiry_date: new Date().getTime(),
                created_at: new Date().getTime(),
                started_at: new Date().getTime(),
            };

            await business.createPayment(payParams);
        }

        // let assume 10 rs is equal to 1 point, will fetch this value from database

        if (customer) {
            const pointsRate = 10;
            const redeemedPoints = Number(order.redeemed_points || 0);
            const pointsEarned = Math.ceil(total / pointsRate);

            await order.updateEarnedPoints(Number(pointsEarned));
            await customer.updateCustomerPoints(pointsEarned, 'add');
            await customer.updateCustomerPoints(redeemedPoints, 'subtract');

            if (method === 'credit') {
                await customer.updateCredit(Number(total), 'add');
            }
        }

        setSuccessModal({
            total,
            change,
            method,
        });

        if (posDiscount) {
            await posDiscount.updateTotalGiven(givenPosDiscount);
        }
        Sync(user.username);
        unbindShortcuts();
    };

    const {unbindShortcuts} = useShortcut({
        keys: [{key: 'enter', action: handleDone}],
    });

    const handleItemDiscount = () => {
        setOrderDiscountModal(true);
    };

    const handleOrderDiscount = async (type, value) => {
        let discountAvailable = orderselectedItem?.discount;
        let discountObj = {
            value,
            type,
        };
        await orderselectedItem?.updateItemDistcount(discountObj);
        setOrderDiscountModal(false);
        if (!discountAvailable) {
            setShowMessage({
                visible: true,
                message: I18n.item_level_discount_added,
            });
        }
    };

    const handleSelectedItem = item => {
        setOrderselectedItem(item);
    };

    const handleToggleAccountModal = () => {
        setToggleWalletModal(prev => !prev);
    };
    const handleSelectedWallet = val => {
        setSelectedWallet(val);
        handleToggleAccountModal();
    };

    const handleSaveAccountNo = val => {
        handleToggleAccountModal(); // api fetch account details
        settoggleVerifyModal(true);

        setTimeout(() => {
            handleToggleAccountModal();
            settoggleVerifyModal(false);
        }, '2000');
    };

    const hanldeSplitBill = () => {
        setSplitBillModal(true);
    };

    const hanldeOrderNoteModal = async () => {
        setOrderNotes(order);
    };

    const updateOrderNotes = async orderNote => {
        await order.updateOrderNotes(orderNote);
    };

    return (
        <section className="posBillingMain" style={{height: DEVICE_HEIGHT - 45}}>
            <Container fluid className="noPadding">
                <Row className="posSectionRow noMargin">
                    <LeftPane>
                        <NewPosHeader
                            title={{
                                name: I18n.order_details,
                            }}
                            leftAction={
                                isRestaurantPos
                                    ? {
                                          title: 'Split bill',
                                          textColor: theme.barclaysBlue,
                                          action: hanldeSplitBill,
                                      }
                                    : {
                                          title: customer?.name || I18n.add_customer,
                                          icon_name: customer ? 'profileTicketIcon' : 'add2Icon',
                                          textColor: theme.barclaysBlue,
                                          action: toggleSelectCustomer,
                                      }
                            }
                            rightAction={
                                isRestaurantPos
                                    ? {
                                          title: discount?.name || I18n.order_discount,
                                          textColor: theme.barclaysBlue,
                                          action: togglePosDiscount,
                                      }
                                    : {
                                          title: order?.note ? I18n.note_added : I18n.order_note,
                                          textColor: theme.barclaysBlue,
                                          action: hanldeOrderNoteModal,
                                      }
                            }
                            backBtnCta={true}
                        />

                        {orderLines?.length ? (
                            <div
                                className="posrightSectionInner"
                                style={{
                                    height: DEVICE_HEIGHT - 105,
                                    backgroundColor: theme.newposRightBg,
                                }}>
                                <div
                                    className="cartItemList"
                                    style={{
                                        height: '60%',
                                    }}>
                                    {orderLines?.map((item, index) => (
                                        <OrderItem
                                            item={item}
                                            key={index}
                                            isOpenItem={item.is_open}
                                            handleSelectedItem={handleSelectedItem}
                                            handleProduct={handleProduct}
                                            handleItemDiscount={handleItemDiscount}
                                            restauratPos={isRestaurantPos}
                                            paymentScreen={true}
                                        />
                                    ))}
                                </div>

                                <div
                                    className="pospaymentScreenAmountBox"
                                    style={{
                                        height: '40%',
                                    }}>
                                    <BillAmountBox
                                        className={`width100`}
                                        subTotal={subTotal}
                                        total={total}
                                        tax={tax}
                                        giveItemLevelDiscount={giveItemLevelDiscount}
                                        givenPosDiscount={givenPosDiscount}
                                        redeemAmount={redeemAmount}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div
                                className="width100"
                                style={{
                                    backgroundColor: 'red',
                                    height: DEVICE_HEIGHT - 105,
                                }}>
                                <NonIdealScreen
                                    heading={I18n.session}
                                    backgroundColor={theme.topBarBG}
                                    subHeading={I18n.please_go_to_the_POS_and_add_items_to_the_list}
                                    name="goToPOSIcon"
                                    fill={theme.white}
                                    secondaryCta={{
                                        title: I18n.go_to_pos,
                                        action: () => navigate(-1),
                                    }}
                                    isMultiStep={false}
                                />
                            </div>
                        )}
                    </LeftPane>
                    <RightPane>
                        <NewPosHeader
                            title={{
                                name: I18n.select_payment_method,
                                color: theme.barclaysBlue,
                            }}
                        />
                        <div
                            style={{
                                height: DEVICE_HEIGHT - 105,
                                backgroundColor: theme.topBarBG,
                            }}>
                            <div className="paymentRightHead">
                                <PaymentMethod
                                    selected={selectedAction}
                                    firstBtn={{
                                        title: I18n.cash,
                                        icon: 'cashIcon2',
                                        action: () => handlePayment('cash'),
                                    }}
                                    secondBtn={{
                                        title: I18n.card,
                                        icon: 'cardIcon2',
                                        action: () => handlePayment('card'),
                                    }}
                                    thirdBtn={{
                                        title: I18n.wallet,
                                        icon: 'walletIcon2',
                                        action: () => handlePayment('wallet'),
                                    }}
                                    fourBtn={{
                                        title: I18n.credit,
                                        icon: 'credit2Icon',
                                        action: () => handlePayment('credit'),
                                    }}
                                />
                            </div>

                            <div className="paymentRightBody width100">
                                {selectedAction === 'cash' || selectedAction === 'credit' ? (
                                    <CashMethod
                                        paymentType={selectedAction}
                                        handleDone={handleDone}
                                        amount={amount}
                                        setAmount={setAmount}
                                        givenPosDiscount={givenPosDiscount}
                                        total={total}
                                        change={change}
                                        customer={customer}
                                        setShowMessage={setShowMessage}
                                        orderLines={orderLines}
                                    />
                                ) : selectedAction === 'wallet' ? (
                                    <WalletMethod orderLines={orderLines} handleSelected={handleSelectedWallet} />
                                ) : (
                                    <CardMethod orderLines={orderLines} givenPosDiscount={givenPosDiscount} total={total} change={change} handleDone={handleDone} />
                                )}
                            </div>
                        </div>
                    </RightPane>
                    <ToastBox className="addSuccessfullyToast" ToastVisiable={showMessage.visible} bodyPara={showMessage.message} setShowMessage={setShowMessage} showIcon={true} />
                </Row>
            </Container>

            <ItemDiscountsModal
                setToggle={setOrderDiscountModal}
                selectedItem={orderselectedItem}
                handleSelectedItem={handleSelectedItem}
                toggle={orderDiscountModal}
                handleSave={handleOrderDiscount}
                showDiscountType
                title={I18n.item_level_discount}
            />
            <PosDiscountModal
                setToggle={setPosDiscountModal}
                toggle={posDiscountModal}
                handleSelect={handlePosDiscount}
                order={order}
                handleDeletePosDiscount={handleDeletePosDiscount}
            />

            <SelectedCustomerModal
                setToggle={setSelectCustomer}
                toggle={selectCustomer}
                handleSelect={handleSelectCustomer}
                order={order}
                handleCreateCustomer={handleCreateCustomer}
            />

            <WalletPaymentModal
                setToggle={setToggleWalletModal}
                toggle={toggleWalletModal}
                selectedWallet={selectedWallet}
                handleSave={handleSaveAccountNo}
                customerInfo={customerInfo}
            />

            <VerificationModal toggle={toggleVerifyModal} setToggle={settoggleVerifyModal} />

            <SplitBillModal toggle={splitBillModal} setToggle={setSplitBillModal} totalBill={total} order={order} business={business} />

            <TransactionSuccessfulModal
                setToggle={setSuccessModal}
                toggle={successModal}
                order={order}
                orderLines={orderLines}
                givenPosDiscount={givenPosDiscount}
                tax={exclusive}
                isRestaurantPos={isRestaurantPos}
                activeOrders={orders}
            />

            <TaxesModal setToggle={setTaxModal} toggle={taxModal} handleTaxSelect={handleTax} order={order} handleDeleteTax={handleDeleteTax} />
            <ItemNotesModal visible={orderNotes} setVisible={setOrderNotes} saveNotes={updateOrderNotes} />
        </section>
    );
};

const enhance = withObservables([''], ({}) => {
    const queryString = window.location.search;
    const parts = queryString?.split('id=');
    const orderNumber = parts[1];

    return {
        orders: orderNumber ? observeGetOrderById(orderNumber) : observeActiveOrder(),
        orderLines: (orderNumber ? observeGetOrderById(orderNumber) : observeActiveOrder()).pipe(
            switchMap(order =>
                order?.length ? order[0].order_line.observeWithColumns(['quantity', 'archive', 'unit', 'discount', 'selling_price', 'order_line_modifiers']) : of(null),
            ),
        ),
        customer: (orderNumber ? observeGetOrderById(orderNumber) : observeActiveOrder()).pipe(switchMap(order => (order?.length ? order[0].customer.observe() : of(null)))),
        discount: (orderNumber ? observeGetOrderById(orderNumber) : observeActiveOrder()).pipe(switchMap(order => (order?.length ? order[0].discount.observe() : of(null)))),
        sales_tax: (orderNumber ? observeGetOrderById(orderNumber) : observeActiveOrder()).pipe(switchMap(order => (order?.length ? order[0].sales_tax.observe() : of(null)))),
    };
});

export default enhance(OrderPayment);
